export const SHOP_V3_URL = 'shop';

export const SHOPIFY_PRODUCT_TAGS_OF_INTEREST = ['V52', 'V53'];
